import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getPollById = (id, time) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.GET_POLL_BY_ID(id, time)
  );
};

export default getPollById;
